<ion-content class="ion-padding">
  <div class="confirm-modal">
    <div class="confirm-modal__content">
      <h2 class="confirm-modal__content__title">
        Voulez vous vraiment annuler cette demande ?
      </h2>
      <img src="../../../assets/img/annuler_demande.svg" alt="confirm message" />

      <p class="confirm-modal__content__message">
        <!-- {{ confirmMessage }} -->
      </p>
      <div class="confirm-modal__content__buttons">
        <button expand="full" class="btn btn-active" (click)="confirm()">
          {{ "ONROAD.VALIDER" | translate }}
        </button>
        <button expand="full" class="btn btn-inactive" (click)="cancel()">
          {{ "ONROAD.CANCEL" | translate }}
        </button>
      </div>
    </div>
  </div>
</ion-content>